// const SYMBOLS = {
//   USD: "$",
//   CAD: "$",
//   EUR: "€",
//   AED: "AED",
//   AFN: "؋",
//   ALL: "Lek",
//   AMD: "֏",
//   ARS: "$",
//   AUD: "$",
//   AZN: "₼",
//   BAM: "KM",
//   BDT: "৳",
//   BGN: "лв.",
//   BHD: "د.ب.‏",
//   BIF: "FBu",
//   BND: "$",
//   BOB: "Bs",
//   BRL: "R$",
//   BWP: "P",
//   BYN: "BY",
//   BZD: "$",
//   CDF: "FrCD",
//   CHF: "₣",
//   CLP: "$",
//   CNY: "¥",
//   COP: "$",
//   CRC: "₡",
//   CVE: "CV$",
//   CZK: "Kč",
//   DJF: "Fdj",
//   DKK: "Kr.",
//   DOP: "RD$",
//   DZD: "د.ج.‏",
//   EEK: "kr",
//   EGP: "ج.م.‏",
//   ERN: "Nfk",
//   ETB: "Br",
//   GBP: "£",
//   GEL: "ლ",
//   GHS: "GH₵",
//   GNF: "FG",
//   GTQ: "Q",
//   HKD: "$",
//   HNL: "L",
//   HRK: "kn",
//   HUF: "Ft",
//   IDR: "Rp",
//   ILS: "₪",
//   INR: "₹",
//   IQD: "IQD",
//   IRR: "﷼",
//   ISK: "kr",
//   JMD: "$",
//   JOD: "د.أ.‏",
//   JPY: "￥",
//   KES: "Ksh",
//   KHR: "៛",
//   KMF: "FC",
//   KRW: "₩",
//   KWD: "د.ك.‏",
//   KZT: "₸",
//   LAK: "₭",
//   LBP: "ل.ل.‏",
//   LKR: "SL Re",
//   LTL: "Lt",
//   LVL: "Ls",
//   LYD: "د.ل.‏",
//   MAD: "د.م.‏",
//   MDL: "L",
//   MGA: "Ar",
//   MKD: "MKD",
//   MMK: "K",
//   MOP: "MOP$",
//   MUR: "MURs",
//   MXN: "$",
//   MYR: "RM",
//   MZN: "MTn",
//   NAD: "N$",
//   NGN: "₦",
//   NIO: "C$",
//   NOK: "kr",
//   NPR: "नेरू",
//   NZD: "$",
//   OMR: "ر.ع.‏",
//   PAB: "B/.",
//   PEN: "S/",
//   PHP: "₱",
//   PKR: "Rs",
//   PLN: "zł",
//   PYG: "₲",
//   QAR: "ر.ق.‏",
//   RON: "lei",
//   RSD: "дин.",
//   RUB: "₽",
//   RWF: "FR",
//   RLS: "﷼",
//   SAR: "ر.س.‏",
//   SDG: "SDG",
//   SEK: "kr",
//   SGD: "S$",
//   SOS: "Ssh",
//   SYP: "ل.س.‏",
//   THB: "฿",
//   TND: "DT",
//   TOP: "T$",
//   TRY: "₺",
//   TTD: "$",
//   TWD: "NT$",
//   TZS: "TSh",
//   UAH: "₴",
//   UGX: "USh",
//   UYU: "$U",
//   UZS: "лв",
//   VEF: "Bs.",
//   VND: "₫",
//   XAF: "FCFA",
//   XOF: "XOF",
//   YER: "ر.ي.‏",
//   ZAR: "R",
//   ZMK: "ZK",
//   ZWL: "ZWL$",
//   KGS: "KGS",
//   LSL: "FUN",
//   BTC: "₿",
//   MBC: "m₿",
//   UBC: "u₿",
//   FTN: "FTN",
//   ONR: "ONR",
//   ORD: "ORD",
//   SZL: "SZL",
//   MNT: "₮",
//   ZMW: "ZK",
//   "FC.": "FC.", // Fortune Coins
//   "GC.": "GC.", // Fortune Coins / Yellow Social Interactive
//   "SC.": "SC.", // Yellow Social Interactive
//   ELY: "ELY", // ELYSIUM Coin
//   XOR: "XOR",
//   XON: "XON",
//   XEL: "XEL",
//   XGC: "GC", // Social Gold Coin,
//   FFC: "FC", // Fortune Coin
//   XSC: "SC", // Social Sweeps Coin
//   FUN: "",
// };
//
//
//
const CURRENCIES = {
  // XGC: { symbol: "GC" }, // Social Gold Coin,
  // FFC: { symbol: "FC" }, // Fortune Coin
  // XSC: { symbol: "SC" }, // Social Sweeps Coin
  FUN: { symbol: "" },
  BGN: { position: "right" },
};
export type CurrencyCode = string;
export type Currency = {
  code?: string;
  isoCode?: string;
  symbol: string;
  position: "left" | "right";
};

// TODO this method as well as the SYMBOLS map is no longer used
// delete it at some point
export const formatCurrencyFromCode = (
  value: string | number,
  code: string,
  position: "left" | "right" = "left"
): string => {
  // const symbol = SYMBOLS[code];
  const symbol = "";

  if (!symbol) {
    console.warn("There is no symbols for currency code", code);
    return formatCurrency(value, { code, symbol: code, position });
  }

  return formatCurrency(value, { code, symbol, position });
};

export const getCurrency = (currency: {
  symbol?: string;
  code?: string;
  isoCode?: string;
  position?: "left" | "right";
}): { code: string; symbol: string; position: "left" | "right" } => {
  const _code = currency.code || currency.isoCode || "";
  const localCfg = (CURRENCIES as any)[_code] ?? {};
  const position = localCfg.position || currency.position || "left";

  return { ...currency, ...localCfg, position };
};

export const formatCurrency = (
  value: string | number,
  currency: Currency
): string => {
  const parseValue = typeof value === "string" ? parseFloat(value) : value;
  // in case something went wrong with the parsing
  const amount = !isNaN(parseValue) ? parseValue.toFixed(2) : value;
  const symbol = currency.symbol ?? "";

  if (currency.position === "right") {
    return amount + symbol;
  } else {
    return symbol + amount;
  }
};
